function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "late-bet-icon",
  transform: "translate(0 0.682)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Caminho_909",
  "data-name": "Caminho 909",
  transform: "translate(0 2.328)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.731,0A8.731,8.731,0,1,1,0,8.731,8.731,8.731,0,0,1,8.731,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 8.730790138244629 1.5 C 4.743720054626465 1.5 1.5 4.743720054626465 1.5 8.730790138244629 C 1.5 12.71786022186279 4.743720054626465 15.96158027648926 8.730790138244629 15.96158027648926 C 12.71786022186279 15.96158027648926 15.96158027648926 12.71786022186279 15.96158027648926 8.730790138244629 C 15.96158027648926 4.743720054626465 12.71786022186279 1.5 8.730790138244629 1.5 M 8.730790138244629 0 C 13.5526704788208 0 17.46158027648926 3.908909797668457 17.46158027648926 8.730790138244629 C 17.46158027648926 13.5526704788208 13.5526704788208 17.46158027648926 8.730790138244629 17.46158027648926 C 3.908909797668457 17.46158027648926 0 13.5526704788208 0 8.730790138244629 C 0 3.908909797668457 3.908909797668457 0 8.730790138244629 0 Z",
  stroke: "none",
  fill: "#00a9ff"
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_920",
  "data-name": "Caminho 920",
  d: "M0,0H3.131",
  transform: "translate(7.029 0.068)",
  fill: "#00a9ff",
  stroke: "#00a9ff",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_917",
  "data-name": "Caminho 917",
  d: "M0,0V2.451",
  transform: "translate(8.663 0)",
  fill: "#00a9ff",
  stroke: "#00a9ff",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_914",
  "data-name": "Caminho 914",
  d: "M0,0,2.587,2.314",
  transform: "translate(13.564 3.54)",
  fill: "#00a9ff",
  stroke: "#00a9ff",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_913",
  "data-name": "Caminho 913",
  d: "M0,0H3.676",
  transform: "translate(0.532 10.718)",
  fill: "#00a9ff",
  stroke: "#00a9ff",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_910",
  "data-name": "Caminho 910",
  d: "M0,0H3.676",
  transform: "translate(8.594 15.823) rotate(90)",
  fill: "#00a9ff",
  stroke: "#00a9ff",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_905",
  "data-name": "Caminho 905",
  d: "M2550,1446v6.4l4.765,4.712s2.928-2.02,1.566-6.6S2550,1446,2550,1446Z",
  transform: "translate(-2541.405 -1441.585)",
  fill: "#00a9ff"
}));

function SvgLateBetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.462,
    height: 20.472,
    viewBox: "0 0 17.462 20.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLateBetIcon);
export default __webpack_public_path__ + "static/media/late-bet-icon.23a20b6b.svg";
export { ForwardRef as ReactComponent };